import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForInteraction } from '@atlassian/react-async';
import parameters from './__generated__/HelpCenterManagementAppQuery$parameters';
import type {
	HelpCenterManagementAppQuery,
	HelpCenterSortOrder,
	HelpCenterType,
} from './__generated__/HelpCenterManagementAppQuery.graphql';

const NUMBER_OF_HELP_CENTERS_INITIAL_FETCH = 20;
const SORT_ORDER: HelpCenterSortOrder = 'CREATED_DATE_DESCENDING';
const FILTER_TYPE: HelpCenterType = 'HELP_HUB';

type HelpCenterManagementAppEntryPointComponentProps = EntryPointComponent<
	{ helpCentresQuery: HelpCenterManagementAppQuery },
	{},
	{},
	{} | null
>;

export const helpCenterManagementAppEntryPoint: EntryPoint<
	HelpCenterManagementAppEntryPointComponentProps,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<HelpCenterManagementAppEntryPointComponentProps>(
		/* webpackChunkName: "async-help-center-management-app" */ './HelpCenterManagementApp.tsx',
	),
	getPreloadProps: ({ tenantContext: { cloudId, activationId } }: EntryPointRouteParams) => ({
		queries: {
			helpCentresQuery: {
				parameters,
				variables: {
					cloudId,
					workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`,
					SORT_ORDER,
					NUMBER_OF_HELP_CENTERS_INITIAL_FETCH,
					filterType: FILTER_TYPE,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
